"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const progressBar_module_scss_1 = __importDefault(require("./progressBar.module.scss"));
const ProgressBar = ({ value, min = 0, max = 100, className = '' }) => {
    const innerStyle = {};
    innerStyle.width = `${value}%`;
    if (min > 0) {
        innerStyle.minWidth = `${min}%`;
    }
    if (max < 100) {
        innerStyle.maxWidth = `${max}%`;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(progressBar_module_scss_1.default.track, className), role: "progressbar", "aria-valuenow": value, "aria-valuemin": min, "aria-valuemax": max, children: (0, jsx_runtime_1.jsx)("div", { className: progressBar_module_scss_1.default.bar, style: innerStyle }) }));
};
exports.default = ProgressBar;
